// ABOUTME: Compact count pill shown behind a sidebar menu entry (e.g. orders to process).
// ABOUTME: Renders nothing unless the count is a positive number, matching the views-menu badges.

import { Box } from "@mui/material";

// The sidebar is dark in both themes, so a translucent white pill with white text fits either mode.
const MenuCountLabel = ({ count }) => {
    if (!(count > 0)) return null;

    return (
        <Box
            sx={{
                ml: 'auto',
                mr: 0.5,
                height: 20,
                minWidth: 20,
                lineHeight: "20px",
                borderRadius: "5px",
                px: 0.75,
                background: "rgba(255,255,255,.14)",
                color: "#fff",
                fontWeight: 700,
                fontSize: 12,
                fontFamily: "Roboto, sans-serif",
                textAlign: "center",
                flexShrink: 0,
            }}
        >
            {count}
        </Box>
    );
};

export default MenuCountLabel;
